const emailAddressRegularExpression =
  // oxlint-disable-next-line unicorn/no-unsafe-regex
  /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;

export const isEmailAddressValid = (emailAddress) => {
  return emailAddressRegularExpression.test(emailAddress.toLowerCase());
};
